import React, { useEffect, useState } from 'react';
import {
    FaUser,
    FaCalendarAlt,
} from 'react-icons/fa';
import './ReportAssignments.css';
import { Box } from '@mui/material';
import CustomModal from '../../../../../../Components/custom_components/CustomModal/CustomModal';
import CustomAddButton from '../../../../../../Components/custom_components/CustomAddButton/CustomAddButton';
import CustomSearchBar from '../../../../../../Components/custom_components/CustomSearchBar/CustomSearchBar';
import { ReportDescription } from '../ReportDescription/ReportDescription';
import CustomSkelton from '../../../../../../Components/Skeletons/CustomSkelton';
import CustomTooltipWithoutRoundBorder from '../../../../../../Components/CustomActionButtonWithTooltip/CustomTooltipWithoutRoundBorder';


const columnStyle = { display: 'flex', gap: '20px', marginBottom: '20px', padding: '10px', width: '100%' };
const renderSkeletonCard = () => (
    <div style={columnStyle}>
        <CustomSkelton
            variant="rounded"
            height={140}
            width={`100%`}
            animation="wave"
            style={{ borderRadius: '12px', marginRight: '20px' }}
        />
    </div>
);

const ReportAssignments = (
    {
        scheduleInfo,
        reportsData,
        scheduleId,
        handleOpenReportModal,
        handleOpenReportStatusModal,
        handleMarkCompleteModal,

        isViewReport,
        isAddReport,
        isReAssignReport,
        isChangeReportStatus,
        isChangeReportProcess,

        isLoading,
        isScheduleCanceled
    }) => {


    const [open, setOpen] = useState(false);
    const [selectedReport, setSelectedReport] = useState(null);

    const [searchText, setSearchText] = useState('');
    const [filteredReports, setFilteredReports] = useState(reportsData); // Initial state set to all reports

    const handleCloseModal = () => {
        setOpen(false);
        setSelectedReport(null);
    };

    // for get the report individual id
    const getSHRDId = (processArray = [], latestStatusId) => {
        const matchedProcess = processArray?.find(
            (item) => item?.Type_ID === latestStatusId
        );
        return matchedProcess?.Result?.[0]?.SHRD_Id || null;
    };

    // FOR GET CURRENT STATUS OF THE REPORT ISCOMPLEETD/PENDING

    const getCurrentReportStatus = (processArray = [], latestStatusId, report = {}) => {
        const matched = processArray?.find(p => p?.Type_ID === latestStatusId);
        const result = matched?.Result?.[0] || {};
        return {
            isComplted_id: result?.isComplted_id ?? report?.isComplted_id ?? null,
            isComplted: result?.isComplted ?? report?.isComplted ?? null,
            isAcceptedBy: result?.acceptedBy ?? report?.acceptedBy ?? null,
            isCurretStatus: matched?.Type || null,
        };
    };
    // FOR CHECK THE SCHEDULE IS ATLEAST ACCEPT FOR SHOW THE REPORT ADD BUTTON
    const hasAcceptedEmployee = () => {
        return scheduleInfo?.schedule_employee?.some(item => item?.SEMP_isAccept == 1);
    };

    // FOR FILTER HANDLINGN VIA TEXT STRING
    useEffect(() => {

        const handleSearchFilter = setTimeout(() => {

            if (searchText.trim() === '') { //search empty case
                setFilteredReports(reportsData)

            } else { //non emplty search
                const lowercasedSearchText = searchText?.toLowerCase();
                const result = reportsData?.filter(report =>
                    report.report_name?.toLowerCase().includes(lowercasedSearchText)
                )
                setFilteredReports(result)
            }

        }, 500) // delay: 500ms
        return () => {
            clearTimeout(handleSearchFilter);
        };
    }, [searchText, reportsData])

    return (
        <div className="report-section">

            {isLoading ? (
                <>
                    {renderSkeletonCard()}
                </>

            ) : (
                <div className="report-header-container">
                    <div className="report-header-left">
                        {isAddReport && (
                            <CustomAddButton
                                label="Add Report"
                                onClick={() => handleOpenReportModal(null, scheduleId, null)}
                            />
                        )}
                    </div>

                    <div className="report-header-search">
                        <CustomSearchBar
                            value={searchText}
                            onChange={setSearchText}
                            placeholder="Search by Report name"
                        />
                    </div>
                </div >
            )}


            {isLoading ? (
                <div className="schedule-details-loader-container">
                    {renderSkeletonCard()} {renderSkeletonCard()}
                    {renderSkeletonCard()} {renderSkeletonCard()}
                </div>
            ) : (
                <>
                    {/* Reports Grid */}
                    <div className="report-assignment-grid">
                        {filteredReports?.length > 0 ? (
                            filteredReports.map((report, index) => {
                                const status = getCurrentReportStatus(
                                    report?.Process,
                                    report?.latest_status_id,
                                    report
                                );
                                return (
                                    <div key={index} className="report-card">
                                        <span className="report-title">{report?.report_name}</span>
                                        <span style={{ color: '#1976d2' }}>
                                            {status?.isComplted_id === 0
                                                ? `On ${status?.isCurretStatus}`
                                                : report?.latest_status}
                                        </span>

                                        <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                                            {/* View */}
                                            {isViewReport &&
                                                <CustomTooltipWithoutRoundBorder title="View">
                                                    <span
                                                        onClick={() => {
                                                            setSelectedReport(report);
                                                            setOpen(true);
                                                        }}
                                                        className="report-status clickable report-view-button"
                                                    >
                                                        View
                                                    </span>
                                                </CustomTooltipWithoutRoundBorder>}

                                            {/* Process */}
                                            {!isScheduleCanceled && isChangeReportProcess && status?.isComplted_id === 1 && report?.latest_status_id !== 5 && (
                                                <CustomTooltipWithoutRoundBorder title="Change Report Process">

                                                    <span
                                                        className="report-status clickable report-statuschange-button"
                                                        onClick={() =>
                                                            handleOpenReportStatusModal(
                                                                scheduleId,
                                                                report?.latest_status_id,
                                                                getSHRDId(report?.Process, report?.latest_status_id)
                                                            )
                                                        }
                                                    >
                                                        Process
                                                    </span>
                                                </CustomTooltipWithoutRoundBorder>
                                            )}

                                            {/* Re-Assign */}
                                            {!isScheduleCanceled && isReAssignReport && status?.isComplted_id === 0 && (
                                                <CustomTooltipWithoutRoundBorder title="Re-Assign">
                                                    <span
                                                        className="report-status clickable report-reassign-button"
                                                        onClick={() =>
                                                            handleOpenReportStatusModal(
                                                                scheduleId,
                                                                report?.latest_status_id,
                                                                getSHRDId(report?.Process, report?.latest_status_id),
                                                                'reassign'
                                                            )
                                                        }
                                                    >
                                                        Re-Assign
                                                    </span>
                                                </CustomTooltipWithoutRoundBorder>
                                            )}

                                            {/* Change Status */}
                                            {!isScheduleCanceled && isChangeReportStatus && status?.isComplted_id === 0 && status?.isAcceptedBy !== null && (
                                                <CustomTooltipWithoutRoundBorder title="Change Status">
                                                    <span
                                                        className="report-status clickable report-changestatus-button"
                                                        onClick={() =>
                                                            handleMarkCompleteModal(
                                                                true,
                                                                scheduleId,
                                                                [getSHRDId(report?.Process, report?.latest_status_id)]
                                                            )
                                                        }
                                                    >
                                                        Change Status
                                                    </span>
                                                </CustomTooltipWithoutRoundBorder>
                                            )}
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <p className="no-data-message">No records found</p>
                        )}
                    </div>

                </>
            )}


            {/* Modal */}
            {
                open && (
                    <CustomModal
                        open={open}
                        handleClose={handleCloseModal}
                        title={`${selectedReport?.report_name}`}
                        body={
                            <Box className="report-modal-box">
                                <div className="stage-section">
                                    {selectedReport?.Process?.map((stageType, idx) => stageType?.Type_ID != 5 ? (
                                        <div className="stage-card" key={`stage-${idx}`}>

                                            <div className="stage-header">
                                                <span className="report-stage">
                                                    {stageType?.Type || `Stage ${idx + 1}`}
                                                </span>
                                                {stageType?.Result?.some((item) =>
                                                    typeof item?.isComplted === 'string' &&
                                                    item.isComplted.toLowerCase() !== 'completed'
                                                ) && (
                                                        <div className="report-status-badge report-status-badge-pending">
                                                            Pending
                                                        </div>
                                                    )}
                                            </div>

                                            {Array.isArray(stageType?.Result) && stageType.Result.length > 0 ? (
                                                stageType.Result.map((resultItem, resultIdx) => (
                                                    <>

                                                        <div key={`result-${idx}-${resultIdx}`} className='report-accept-reject-container'>
                                                            {/* Assigned */}
                                                            {/* {resultItem?.acceptedBy == null &&
                                                                Array.isArray(resultItem?.assigned_users) &&
                                                                resultItem.assigned_users.length > 0 && (
                                                                    <div className="assigned-report-container">
                                                                        <h4 className="assigned-report-title">Assigned</h4>
                                                                        <div className="assigned-report-scroll">
                                                                            <div className="assigned-report-list">
                                                                                {resultItem.assigned_users.map((user, index) => (
                                                                                    <div key={`assigned-${idx}-${resultIdx}-${index}`} className="assigned-report-card">
                                                                                        <div className="assigned-report-item">
                                                                                            <FaUser className="assigned-report-icon" />
                                                                                            <span><strong>Name:</strong> {user?.name || 'N/A'}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                )} */}

                                                            {/* Accepted */}
                                                            {/* {resultItem?.acceptedBy && ( */}
                                                            <div className="accepted-report-container">
                                                                <h4 className="accepted-report-title">Accepted</h4>
                                                                <div className="accepted-report-card">
                                                                    {/* <div className="accepted-report-item">
                                                                        <FaUserTie className="accepted-report-icon" />
                                                                        <span><strong>Assigned by:</strong> {resultItem?.assigned_by || 'N/A'}</span>
                                                                    </div> */}
                                                                    {/* <div className="accepted-report-item">
                                                                        <FaCalendarAlt className="accepted-report-icon" />
                                                                        <span><strong>Assigned on:</strong> {resultItem?.assigned_Date || 'N/A'}</span>
                                                                    </div> */}
                                                                    <div className="accepted-report-item">
                                                                        <FaUser className="accepted-report-icon" />
                                                                        <span><strong>Accepted by:</strong> {resultItem?.acceptedBy || 'N/A'}</span>
                                                                    </div>
                                                                    <div className="accepted-report-item">
                                                                        <FaCalendarAlt className="accepted-report-icon" />
                                                                        <span><strong>Accepted on:</strong> {resultItem?.accepted_Date || 'N/A'}</span>
                                                                    </div>
                                                                    {/* <div className="accepted-report-item">
                                                                        <GrDocumentVerified className="accepted-report-icon" />
                                                                        <span><strong>Submitted by:</strong> {resultItem?.acceptedBy || 'N/A'}</span>

                                                                    </div> */}
                                                                    <div className="accepted-report-item">
                                                                        <FaCalendarAlt className="accepted-report-icon" />
                                                                        <span><strong>Submitted On:</strong> {resultItem?.isComplted_on || 'N/A'}</span>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* )} */}

                                                            {/* Rejected */}
                                                            {Array.isArray(resultItem?.rejected_users) && resultItem.rejected_users.length > 0 && (
                                                                <div className="rejected-report-container">
                                                                    <h4 className="rejected-report-title">Rejected</h4>
                                                                    <div className="rejected-report-scroll">
                                                                        <div className="rejected-report-list">
                                                                            {resultItem.rejected_users.map((user, index) => (
                                                                                <div
                                                                                    key={`rejected-${idx}-${resultIdx}-${index}`}
                                                                                    className="rejected-report-card"
                                                                                >
                                                                                    <div className="rejected-report-item">
                                                                                        <FaUser className="rejected-report-icon" />
                                                                                        <span>
                                                                                            <strong>Name:</strong> {user?.name || 'N/A'}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {/* ===== Description Section ===== */}
                                                        {/* Type_ID =5 means submit */}
                                                        {stageType?.Type_ID != 5 &&
                                                            <div>
                                                                <ReportDescription description={resultItem?.description || `N/A`} />
                                                            </div>
                                                        }

                                                    </>
                                                ))
                                            ) : (
                                                <div className="report-detail">
                                                    <p className="no-data-message">No records found</p>
                                                </div>
                                            )}
                                        </div>
                                    ) : (stageType?.Type_ID == 5 && stageType?.Result.length > 0 ? (

                                        <div className="submittedto-superviosr-status-message">
                                            <span>✅</span>
                                            <span>Submitted to Supervisor</span>
                                        </div>
                                    ) : null

                                    ))}
                                </div>
                            </Box >
                        }
                        maxWidth="79%"
                    />
                )
            }
        </div >
    );
};

export default ReportAssignments;



{/* REPORTS CARD */ }
// <div className="report-assignment-grid">
//     {reportsData?.length > 0 &&
//         reportsData.map((report, index) => {
//             const status = getCurrentReportStatus(report?.Process, report?.latest_status_id, report);

//             return (
//                 <div key={index} className="report-card">
//                     <span className="report-title">{report?.report_name}</span>
//                     <span style={{ color: '#1976d2' }}>
//                         {status?.isComplted_id === 0 ? `On ${status?.isCurretStatus}` : report?.latest_status}
//                     </span>

//                     {/* BUTTONS */}
//                     <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
//                         {/* VIEW BUTTON */}
//                         <CustomTooltip title="View">
//                             <span
//                                 onClick={() => handleOpenModal(report)}
//                                 className="report-status clickable report-view-button"
//                             >
//                                 View
//                             </span>
//                         </CustomTooltip>

//                         {/* PROCESS BUTTON */}
//                         {status?.isComplted_id === 1 && report?.latest_status_id !== 4 && (
//                             <CustomTooltip title="Change Report Process">
//                                 <span
//                                     className="report-status clickable report-statuschange-button"
//                                     onClick={() =>
//                                         handleOpenReportStatusModal(
//                                             scheduleId,
//                                             report?.latest_status_id,
//                                             getSHRDId(report?.Process, report?.latest_status_id)
//                                         )
//                                     }
//                                 >
//                                     Process
//                                 </span>
//                             </CustomTooltip>
//                         )}

//                         {/* REASSIGN BUTTON */}
//                         {status?.isComplted_id === 0 && (
//                             <CustomTooltip title="Re-Assign">
//                                 <span
//                                     className="report-status clickable report-reassign-button"
//                                     onClick={() =>
//                                         handleOpenReportStatusModal(
//                                             scheduleId,
//                                             report?.latest_status_id,
//                                             getSHRDId(report?.Process, report?.latest_status_id),
//                                             'reassign'
//                                         )
//                                     }
//                                 >
//                                     Re-Assign
//                                 </span>
//                             </CustomTooltip>
//                         )}

//                         {/* CHANGE STATUS BUTTON */}
//                         {status?.isComplted_id === 0 && status?.isAcceptedBy !== null && (
//                             <CustomTooltip title="Change Status">
//                                 <span
//                                     className="report-status clickable report-changestatus-button"
//                                     onClick={() =>
//                                         handleMarkCompleteModal(
//                                             true,
//                                             scheduleId,
//                                             [getSHRDId(report?.Process, report?.latest_status_id)]
//                                         )
//                                     }
//                                 >
//                                     Change Status
//                                 </span>
//                             </CustomTooltip>
//                         )}
//                     </div>
//                 </div>
//             );
//         })}
// </div>


















{/* <div key={resultIdx} className="result-block">
                                                        <div className="report-detail">
                                                            <FaUserTie className="detail-icon" />
                                                            <span>
                                                                <strong>Assigned by:</strong>{' '}
                                                                {resultItem?.assigned_by || 'N/A'}
                                                            </span>
                                                        </div>

                                                        <div className="report-detail">
                                                            <FaCalendarAlt className="detail-icon" />
                                                            <span>
                                                                <strong>Assigned on:</strong>{' '}
                                                                {resultItem?.assigned_Date || 'N/A'}
                                                            </span>
                                                        </div>

                                                        <div className="report-detail">
                                                            <FaUser className="detail-icon" />
                                                            <span>
                                                                <strong>Accepted by:</strong>{' '}
                                                                {resultItem?.acceptedBy || 'N/A'}
                                                            </span>
                                                        </div>

                                                        <div className="report-detail">
                                                            <FaCalendarAlt className="detail-icon" />
                                                            <span>
                                                                <strong>Accepted on:</strong>{' '}
                                                                {resultItem?.accepted_Date || 'N/A'}
                                                            </span>
                                                        </div>

                                                        <div className="report-detail">
                                                            <GrDocumentVerified className="detail-icon" />
                                                            <span>
                                                                <strong>Submitted by:</strong>{' '}
                                                                {resultItem?.acceptedBy || 'N/A'}
                                                            </span>
                                                            <span>
                                                                <strong> on:</strong>{' '}
                                                                {resultItem?.isComplted_on || 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div> */}

{/* ACCPETED USER */ }
{/* <div key={resultIdx} className="accepted-report-container">
                                                        <h4 className="accepted-report-title"> Accepted User </h4>

                                                        <div className="accepted-report-card">
                                                            <div className="accepted-report-item">
                                                                <FaUserTie className="accepted-report-icon" />
                                                                <span><strong>Assigned by:</strong> {resultItem?.assigned_by || 'N/A'}</span>
                                                            </div>

                                                            <div className="accepted-report-item">
                                                                <FaCalendarAlt className="accepted-report-icon" />
                                                                <span><strong>Assigned on:</strong> {resultItem?.assigned_Date || 'N/A'}</span>
                                                            </div>

                                                            <div className="accepted-report-item">
                                                                <FaUser className="accepted-report-icon" />
                                                                <span><strong>Accepted by:</strong> {resultItem?.acceptedBy || 'N/A'}</span>
                                                            </div>

                                                            <div className="accepted-report-item">
                                                                <FaCalendarAlt className="accepted-report-icon" />
                                                                <span><strong>Accepted on:</strong> {resultItem?.accepted_Date || 'N/A'}</span>
                                                            </div>

                                                            <div className="accepted-report-item">
                                                                <GrDocumentVerified className="accepted-report-icon" />
                                                                <span>
                                                                    <strong>Submitted by:</strong> {resultItem?.acceptedBy || 'N/A'}
                                                                </span>
                                                                <span style={{ marginLeft: '6px' }}>
                                                                    <strong>on:</strong> {resultItem?.isComplted_on || 'N/A'}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div> */}